import { useEffect } from 'react';

import type { RepresentasjonKontekstProps } from '../../types/entities';

import Icon from '@helsenorge/designsystem-react/components/Icon';
import InfoSignStroke from '@helsenorge/designsystem-react/components/Icons/InfoSignStroke';
import Modal from '@helsenorge/designsystem-react/components/Modal';

import { BeholdPerson } from './behold-person';
import { brokerOrigin } from './broker-utils';
/// <reference types="@helsenorge/framework-utils/types/hn"/>

export const RepresentasjonKontekst: React.FC<RepresentasjonKontekstProps> = (props: RepresentasjonKontekstProps) => {
  const {
    errors: { velgRepresentasjonError, hentRepresentasjonError },
    hentRepresentasjon,
    handleAwaken,
    showModal,
    valgtRepresentasjonNavn,
    setShowModal,
  } = BeholdPerson();
  const representertBruker = valgtRepresentasjonNavn.current ?? '';

  useEffect(() => {
    if (!valgtRepresentasjonNavn.current && props.authorized) {
      hentRepresentasjon();
    }
    const handler = (event: MessageEvent): void => {
      if (event.origin !== brokerOrigin) {
        return;
      }

      if (event.data?.type === 'representation-updated') {
        hentRepresentasjon();
      }
      if (event.data?.type === 'not-synced') {
        window.location.reload();
      }
    };
    window.addEventListener('message', handler);
    window.addEventListener('pageshow', () => {
      handleAwaken();
    });
    window.addEventListener('focus', () => {
      handleAwaken();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        handleAwaken();
      }
    });

    return (): void => {
      window.removeEventListener('message', handler);
      window.removeEventListener('pageshow', () => {
        handleAwaken();
      });
      window.removeEventListener('focus', () => {
        handleAwaken();
      });
      document.removeEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') handleAwaken();
      });
    };
  }, []);

  const onNoticed = (): void => {
    setShowModal(false);
  };
  const error = velgRepresentasjonError || hentRepresentasjonError;
  const feilmeldingTitle = props.representasjonModalFeilmelding ?? 'Det har skjedd en teknisk feil';
  const feilmeldingDescription =
    props.representasjonModalFeilmeldingDescription ?? 'Prøv å oppdatere siden. Hvis feilen fortsetter, kan du prøve igjen litt senere.';
  const modalTitle =
    props.representasjonModalTitle?.replace('{navn}', representertBruker) ?? `Du bruker Helsenorge på vegne av ${representertBruker}`;
  const description = error
    ? feilmeldingDescription
    : (props.representasjonModalDescription?.replace('{navn}', representertBruker) ??
      `Du har byttet person i en annen fane. I denne fanen bruker du fremdeles Helsenorge på vegne av ${representertBruker}.`);
  const title = error ? feilmeldingTitle : modalTitle;
  const variant = error ? 'error' : 'normal';
  return (
    <>
      {showModal && (
        <Modal
          title={title}
          icon={<Icon size={38} svgIcon={InfoSignStroke} />}
          variant={variant}
          description={description}
          primaryButtonText={props.representasjonModalKnapp ?? 'Lukk'}
          onSuccess={onNoticed}
          onClose={onNoticed}
        />
      )}
    </>
  );
};
